import { useAuth } from '@/lib'
import { useTranslation } from 'react-i18next'
import { YesNoScreen } from './yes-no-screen'

type Props = {
	onSubmit: (value: boolean) => void
	isSubmitting: boolean
}

export function ContactsCandidatesScreen(props: Props) {
	const { t } = useTranslation()
	const { user } = useAuth()
	return (
		<YesNoScreen
			title={t('onboarding.contactsCandidates.title')}
			subtitle={t('onboarding.contactsCandidates.subtitle')}
			current={user?.contactsCandidates ?? null}
			illustrationSrc="/onboarding/contacts-candidates.png"
			{...props}
		/>
	)
}
